import { createContext, useContext, useMemo, useState } from "react";
import { apiRequest } from "../api/client";

const AuthContext = createContext(null);

function readJson(key) {
  try {
    return JSON.parse(localStorage.getItem(key));
  } catch (error) {
    return null;
  }
}

export function AuthProvider({ children }) {
  const [admin, setAdmin] = useState(readJson("adminUser"));
  const [customer, setCustomer] = useState(readJson("customerUser"));

  const value = useMemo(() => ({
    admin,
    customer,
    async adminLogin(credentials) {
      const data = await apiRequest("/api/auth/admin/login", { method: "POST", body: credentials });
      localStorage.setItem("adminToken", data.token);
      localStorage.setItem("adminUser", JSON.stringify(data.user));
      setAdmin(data.user);
      return data.user;
    },
    adminLogout() {
      localStorage.removeItem("adminToken");
      localStorage.removeItem("adminUser");
      setAdmin(null);
    },
    async customerLogin(credentials) {
      const data = await apiRequest("/api/auth/customer/login", { method: "POST", body: credentials });
      localStorage.setItem("customerToken", data.token);
      localStorage.setItem("customerUser", JSON.stringify(data.user));
      setCustomer(data.user);
      return data.user;
    },
    async customerRegister(payload) {
      const data = await apiRequest("/api/auth/customer/register", { method: "POST", body: payload });
      localStorage.setItem("customerToken", data.token);
      localStorage.setItem("customerUser", JSON.stringify(data.user));
      setCustomer(data.user);
      return data.user;
    },
    customerLogout() {
      localStorage.removeItem("customerToken");
      localStorage.removeItem("customerUser");
      setCustomer(null);
    },
  }), [admin, customer]);

  return <AuthContext.Provider value={value}>{children}</AuthContext.Provider>;
}

export function useAuth() {
  return useContext(AuthContext);
}
